<template>
  <div>
    <h2>送分-语言</h2>
    <Select v-model="selectedType" style="width: 200px" @on-change="changeType">
      <Option v-for="item in languageOption" :value="item" :key="item">{{
        item
      }}</Option>
    </Select>

    <Table class="table" :columns="col1" :data="data"> </Table>

    <Divider>递送学校</Divider>
    <Table class="table" :columns="col2" :data="schoolData.list">
      <template slot-scope="{ row }" slot="number">
        {{ row._index + 1 }}
      </template>
      <template slot-scope="{ row }" slot="name">
        {{ row.school_result.base_info.chn_name }}
      </template>

      <template slot-scope="{ row }" slot="type">
        {{ row.type || "暂无" }}
      </template>
      <template slot-scope="{ row }" slot="dl">
        {{ row.ddl ? $moment(row.ddl).format("YYYY-MM-DD") : "暂无" }}
      </template>
      <template slot-scope="{ row }" slot="waive">
        {{ row.waive || "暂无" }}
      </template>
      <template slot-scope="{ row }" slot="status">
        <template v-if="row.sentPoint_res._id">已发送</template>
        <Button v-else type="primary" size="small" @click="sentPoint(row)"
          >发送</Button
        >
      </template>

      <template slot-scope="{ row }" slot="date">
        <template v-if="row.sentPoint_res._id">
          {{ $moment(row.sentPoint_res.sentTime).format("YYYY-MM-DD") }}
        </template>
        <template v-else> 暂无 </template>
      </template>
    </Table>
  </div>
</template>

<script>
export default {
  data() {
    return {
      languageOption: [],
      selectedType: "",
      data: [],
      col1: [
        {
          title: "当前最佳总分",
          key: "maxScore_total",
        },
        {
          title: "R",
          key: "maxScore_R",
        },
        {
          title: "L",
          key: "maxScore_L",
        },
        {
          title: "S",
          key: "maxScore_S",
        },
        {
          title: "W",
          key: "maxScore_W",
        },
      ],

      schoolData: {},
      col2: [
        {
          title: "NO.",
          slot: "number",
        },
        {
          title: "Name",
          slot: "name",
        },
        {
          title: "Type",
          slot: "type",
        },
        {
          title: "DL",
          slot: "dl",
        },
        {
          title: "Waive",
          slot: "waive",
        },
        {
          title: "Status",
          slot: "status",
        },
        {
          title: "日期",
          slot: "date",
        },
      ],
    };
  },

  methods: {
    async getLanguageOption() {
      let res = await this.api({
        url: "/language/getAlltypeByStudent",
        method: "get",
        params: {
          token: this.$store.getters.token,
          ttoken: this.$store.getters.ttoken,
          student_id: this.$store.getters.selectedStudent._id,
        },
      });

      this.languageOption = res;
      this.selectedType = this.languageOption[0];
    },

    async getInfo() {
      let res = await this.api({
        url: "/language/getInfo",
        method: "get",
        params: {
          token: this.$store.getters.token,
          ttoken: this.$store.getters.ttoken,
          student_id: this.$store.getters.selectedStudent._id,
          type: this.selectedType,
        },
      });

      this.data = [res];
    },

    async getSchoolData(page = 1) {
      let res = await this.api({
        url: "/sent_point/select",
        method: "get",
        params: {
          token: this.$store.getters.token,
          ttoken: this.$store.getters.ttoken,
          student_id: this.$store.getters.selectedStudent._id,
          exam_type: "language",
          exam_name: this.selectedType,
          page: page,
          size: 10,
        },
      });

      this.schoolData = res;
    },

    changeType(val) {
      console.log(val);
      this.getInfo();
      this.getSchoolData();
    },

    async sentPoint(item) {
      this.$Modal.confirm({
        title: this.selectedType + "确定送分:" + item.school_result.base_info.chn_name + "?",
        content: "确定后不可修改",
        closable: true,
        cancelText: "取消",
        onOk: async () => {
          await this.api({
            url: "/sent_point/save",
            method: "post",
            params: {
              token: this.$store.getters.token,
              ttoken: this.$store.getters.ttoken,
            },
            data: {
              student_id: this.$store.getters.selectedStudent._id,
              student_school_selection_id: item._id,
              exam_type: "language",
              exam_name: this.selectedType,
            },
          });

          this.$Message.success("已更新");
          this.getSchoolData();
        },
        onCancel: () => {},
      });
    },
  },

  async mounted() {
    if (!this.$store.getters.selectedStudent._id) {
      return;
    }

    await this.getLanguageOption();
    this.getInfo();
    this.getSchoolData();
  },

  watch: {
    "$store.getters.selectedStudent": async function () {
      await this.getLanguageOption();
      this.getInfo();
      this.getSchoolData();
    },
  },
};
</script>


<style lang="less" scoped>
.table {
  margin-top: 10px;
}

.add-btn {
  margin-top: 10px;
}
</style>